import { CandidatePriority, E_PRIORITIES, F_PRIORITIES, NursingApprenticeshipExperience } from '../candidate';
import { ConfirmationStatus } from '../general';
import { JobTitleCategory, JobTitleSpecification } from '../job-title';

export const mapQualificationAnswerToEnum = (answer: ConfirmationStatus) => {
  switch (answer) {
    case ConfirmationStatus.Yes:
      return NursingApprenticeshipExperience.Yes;

    case ConfirmationStatus.No:
      return NursingApprenticeshipExperience.NoApprenticeship;

    case ConfirmationStatus.InProgress:
      return NursingApprenticeshipExperience.InProgress;

    case ConfirmationStatus.AcquiredAbroad:
      return NursingApprenticeshipExperience.AcquiredAbroad;

    case ConfirmationStatus.BasicNursing:
      return NursingApprenticeshipExperience.BasicNursing;
  }
};

export const getNursingApprenticeshipExperienceFromQualification = (
  mainSpecification: JobTitleSpecification,
  answer?: ConfirmationStatus,
) => {
  const {
    category,
    jobTitle: { trackingPriority },
  } = mainSpecification;

  if (trackingPriority < CandidatePriority.D) return null;
  if (E_PRIORITIES.includes(trackingPriority)) return NursingApprenticeshipExperience.SearchingApprenticeship;
  if (F_PRIORITIES.includes(trackingPriority)) return NursingApprenticeshipExperience.NoApprenticeship;

  switch (answer) {
    case ConfirmationStatus.Yes:
      return category === JobTitleCategory.Praxia ? NursingApprenticeshipExperience.Yes : NursingApprenticeshipExperience.OneTwoYears;

    case ConfirmationStatus.No:
      return NursingApprenticeshipExperience.NoApprenticeship;

    case ConfirmationStatus.InProgress:
      return category === JobTitleCategory.Praxia
        ? NursingApprenticeshipExperience.NoApprenticeship
        : NursingApprenticeshipExperience.InProgress;

    case ConfirmationStatus.BasicNursing:
      return NursingApprenticeshipExperience.BasicNursing;

    case ConfirmationStatus.AcquiredAbroad:
      return NursingApprenticeshipExperience.AcquiredAbroad;
  }
  return null;
};
